"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
function useKeyboardFocus(refs) {
  const {
    0: focusedElement,
    1: setFocusedElement
  } = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    function onFocus(e) {
      e.stopPropagation();
      setFocusedElement(e.currentTarget.getAttribute("name"));
    }
    function onBlur(e) {
      e.stopPropagation();
      setFocusedElement(null);
    }
    function onClick() {
      setFocusedElement(null);
    }
    function onKeyDown(e) {
      // Prevent page from scrolling when pressing enter key
      if (document.activeElement.classList.value.match("keyboard-focus") && e.key === " ") e.preventDefault();
      // Simulate click action for focused elements with a role of button when enter/space key is pressed
      if (e.key && (e.key === "Enter" || e.key === " ")) {
        const activeElement = document.activeElement;
        if (activeElement.getAttribute("role") === "button") activeElement.click();
      }
    }
    const elements = refs.current;
    elements.forEach(ref => {
      if (ref) {
        ref.addEventListener("focus", onFocus);
        ref.addEventListener("blur", onBlur);
      }
    });
    window.onkeydown = onKeyDown;
    window.onclick = onClick;
    return () => {
      elements.forEach(ref => {
        if (ref) {
          ref.removeEventListener("focus", onFocus);
          ref.removeEventListener("blur", onBlur);
        }
      });
      window.onkeydown = null;
      window.onclick = null;
    };
  });
  return focusedElement;
}
var _default = useKeyboardFocus;
exports.default = _default;